import { Component, Inject, OnInit,EventEmitter,Output,OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService, LoggerService, statusCodes ,FlashService } from 'ew-common-lib';
import { EwMaIntegrationService } from "../ew-ma-integration.service";

@Component({
  selector: 'app-list-select-integration',
  templateUrl: './select-list-integration.component.html',
  styleUrls: ['./select-list-integration.component.scss']
})
export class ListSelectIntegrationComponent implements OnInit {
  selectedList:any;
  showPopupLoader = 0;
  @Output() add_integration: any = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<ListSelectIntegrationComponent>,
    private EwMaIntegrationService: EwMaIntegrationService,
    private ewFlashService: FlashService,
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router
    ) {}


    
    closeDailog(type:any): void {
      this.dialogRef.close(type);
    }
  ngOnInit(): void {
    console.log(this.data);
  }

  redirectToAddIntegration(){
    if(this.selectedList){ 
      this.saveSelectedList(this.selectedList,this.data.service_provider);
    }
  }

  saveSelectedList(selectedList,service_provider){
    this.showPopupLoader = 1;
    const  model = {
      'service_provider':service_provider,
      'action':"list",
      'value':selectedList,
      'event_id':this.data.event_id,
     };
     this.EwMaIntegrationService.saveSelectedList(model).subscribe(
       (response: any) => { 
         this.showPopupLoader = 0;
         if (response.status.code == statusCodes.SUCCESS) {    
         // this.router.navigate(['./add-integration',service_provider]);   
          this.add_integration.emit(service_provider);   
          this.closeDailog(service_provider);  
         }
        
       },
       (error) => { 
        this.showPopupLoader = 0;
         this.ewFlashService.openSnackBar("Something went wrong.Please try again.","Got It","error-ew-message");
       }
     );
  

   }

}